<div fxLayout="column" class="w-full fixed h-full">
  <!-- TOP -->
  <div class="bg-1 p-8" fxLayoutAlign="space-between center">
    <div class="btn-top">
      <button (click)="newTicket()" mat-stroked-button class="bg-green-500 text-white">
        <mat-icon>add</mat-icon>
        Nouvelle ticket
      </button>
      <!-- <button (click)="addAvance()" mat-stroked-button>
        <mat-icon>monetization_on</mat-icon>
        Avance
      </button> -->
      <button (click)="openFrmRemiseArticle()" mat-stroked-button disabled>
        <mat-icon>edite</mat-icon>
        Editer
      </button>
      <!-- <button (click)="openFrmEchange('RETOUR')" mat-stroked-button>
        <i class="fas fa-hand-holding-usd"></i>
        Retour
      </button> -->
      <button (click)="openFrmEchange('ECHANGE')" mat-stroked-button>
        <mat-icon>repeat</mat-icon>
        <span toggle-label class="label">&Eacute;change </span>
      </button>

      <!-- <button mat-stroked-button (click)="newDay()" >
                <mat-icon>lock_open</mat-icon>
                <span toggle-label class="label">Nouvelle journée</span>
            </button> -->
      <button mat-stroked-button (click)="openCloseDay()"
        [ngClass]="journerOuvert ? 'background-green' : 'background-red'">
        <mat-icon>{{ journerOuvert ? "lock_open" : "lock" }}</mat-icon>
        <span toggle-label class="label">{{
          journerOuvert ? "Clôturer" : "Ouverture"
        }}</span>
      </button>
      <button mat-stroked-button (click)="goToSituationReglement()">
        <mat-icon>monetization_on</mat-icon>
        <span toggle-label class="label">Situation règlement</span>
      </button>
      <!-- <button mat-stroked-button (click)="saveTicket()">
        <mat-icon>save</mat-icon>
        <span toggle-label class="label">Enregistrer Ticket</span>
      </button> -->
    </div>
    <div>
      <!-- ne pas supprimer  la balise <a routerLink="./" > -->
      <a routerLink="./" #imgKastelo><img style="width: 130px" src="/assets/logo_centre.png" alt="logoClient" /></a>
    </div>
  </div>
  <mat-divider></mat-divider>
  <!-- BODY -->
  <div class="bg-1" fxLayout="row" fxFlex class="vh-79">
    <div fxFlex>
      <div fxFlex fxLayout="column">
        <mat-horizontal-stepper fxFlex (selectionChange)="stepperSelectionChange($event)" #stepper style="height: 70vh">
          <mat-step>
            <ng-template matStepLabel>
              <div class="grid mb-5">
                <span class="text-xs">F1</span>
                <span class="text-xl">
                  {{ mode == "AVANCE" ? "Client" : "Vente" }}
                </span>
              </div>
            </ng-template>
            <div class="stepper-container" fxLayoutGap="12px" fxLayout="row">
              <div fxFlex="80">
                <div class="text-center py-4 text-2xl rounded text-blue-700">
                  {{ articleTemp }}
                </div>
                <div style="overflow: auto">
                  <div class="relative overflow-scroll" style="height: 75vh" fxLayout="column" fxLayoutGap="8px">
                    <div *ngFor="let item of ListProductToshow  " (click)="selectItem(item)">
                      <div *ngIf="item.Qte!=0"
                        class=" w-full p-8 flex justify-start bg-gray-100 shadow-md rounded-md transition" [ngClass]="{ 'selected-item': selectedItem == item,
                                    'selected-item-echange': item.Qte==-1 && selectedItem == item}">

                        <img onerror="this.src='/assets/1.jpg'" [src]="
                          imageDomain +
                          
                          item.Art_Code +
                          '.JPG'
                        " class="rounded-lg w-80" />
                        <div class="grid w-full mx-8 gap-1">
                          <div class="flex justify-between">
                            <span class="font-bold text-xl" [class]="
                              selectedItem == item
                                ? 'text-white'
                                : 'text-gray-700'
                            ">{{ item.Art_Des }} </span>
                            <!-- <div class="grid">
                              <span class="text-sm">Couleur</span>
                              <span class="text-xl text-center">{{
                              item.Art_CAr2
                            }}</span>
                            </div>
                            <div class="grid">
                              <span class="text-sm">Taille</span>
                              <span class="text-xl text-center">{{
                              item.Art_Car1
                            }}</span>
                            </div> -->
                          </div>

                          <div class="flex justify-between font-bold">
                            <div class="grid">
                              <div class="text-center">Quantité</div>
                              <div class="flex justify-between items-center">
                                <div (click)="addItem(item, -1)" class="rounded-full flex justify-center items-center"
                                  [class]="
                                  selectedItem == item
                                    ? 'bg-white
                                    text-red-500'
                                    : 'bg-red-500
                                    text-white'
                                ">
                                  <mat-icon class="text-sm text-center cursor-pointer " style="line-height: 24px">{{
                                    item.Qte > 1 ? "remove" : "delete"
                                  }}</mat-icon>
                                </div>
                                <span class="text-lg mx-8" [class]="
                                  selectedItem == item
                                    ? 'text-white'
                                    : 'text-blue-700'
                                ">{{ item.Qte }}</span>
                                <div (click)="addItem(item, 1)" class="rounded-full flex justify-between items-center"
                                  [class]="
                                  selectedItem == item
                                    ? 'bg-white
                                    text-green-500'
                                    : 'bg-green-500
                                    text-white'
                                ">
                                  <mat-icon class="text-sm text-center cursor-pointer" style="line-height: 24px">add
                                  </mat-icon>
                                </div>
                              </div>
                            </div>
                            <div class="grid">
                              <div>prix unit</div>
                              <div>{{ item.Art_PV }}</div>
                            </div>
                            <div class="grid">
                              <div>total</div>

                              <div class="text-xl" [class]="
                                selectedItem == item
                                  ? 'text-white'
                                  : 'text-red-500'
                              ">
                                {{ (item.Art_PV * item.Qte).toFixed(3) }}
                              </div>
                            </div>
                            <div class="grid">
                              <div>total apres remise</div>

                              <div class="text-xl" [class]="
                                selectedItem == item
                                  ? 'text-white'
                                  : 'text-red-500 flex justify-end'
                              ">
                                {{
                                  item.PTAR | number :"0.3-3"
                              }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overflow-auto" fxFlex fxLayout="column" fxLayoutAlign="space-around">
                <div *ngIf="!selectedItem && selectedClient.Tiers_RS" fxLayoutAlign="center start">
                  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px" class="customer-container">
                    <div class="btn-close-container">
                      <img (click)="openClientDetails()" class="user-avatar mt-12 cursor-pointer"
                        [src]="selectedClient.image" alt="" />
                    </div>
                    <div>
                      {{ selectedClient.Tiers_RS }}
                    </div>
                    <div *ngIf="products">
                      <div fxLayout="column" fxLayoutGap="8px">
                        <div fxLayout="row" fxLayoutGap="20px">
                          <div fxLayoutGap="8px" fxLayout="row">
                            <mat-icon matListIcon>shopping_bag</mat-icon>
                            <div>
                              {{ products.length }}
                            </div>
                          </div>
                          <div fxLayoutGap="8px" fxLayout="row">
                            <mat-icon matListIcon>favorite_border</mat-icon>
                            <div>2.598</div>
                          </div>
                        </div>
                        <mat-icon matListIcon>star</mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start center" *ngIf="selectedItem">
                  <div class="btn-close-container">
                    <!-- <button class="button-close" mat-mini-fab color="default"
                                            (click)="closeSelectedItem()">
                                            <mat-icon>close</mat-icon>
                                        </button> -->
                    <img class="w-400 zoom-70" onerror="this.src='/assets/1.jpg'" [src]="
                        imageDomain +
                         
                        selectedItem.Art_Code +
                        '.JPG'
                      " />
                  </div>
                  <div>
                    <button (click)="removeArticle()" mat-icon-button>
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </div>
                  <div>{{ selectedItem.Art_Des }}</div>
                  <div>{{ selectedItem.Art_Code }}</div>
                  <div>{{ selectedItem.Art_PV | number: "0.3-3" }}</div>
                </div>
                <div *ngIf="selectedVendeur && selectedVendeur.Perso_Nom">
                  <img src="assets/avatar.png" class="seller-img" />
                  <span class="text-overflow">{{
                    selectedVendeur.Perso_Nom
                  }}</span>
                  <mat-icon class="remove-selected-employee-icon" (click)="removeEmployee()">
                    remove_circle_outline
                  </mat-icon>
                </div>
              </div>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>
              <div class="grid mb-5">
                <span class="text-xs">F1</span>
                <span class="text-xl"> Réglement </span>
              </div>
            </ng-template>
            <div [class]="dsDocCash ?'flex justify-between gap-4 ':'flex justify-start gap-4 '">
              <div *ngIf="dsDocCash" class="w-2/5">
                <div
                  *ngIf="dsDocCashR && dsDocCashR.DocCashR.length>0 && dsDocCashR.DocCashR[0].DocCashR_Montant!=null">
                  <div *ngFor="let item of dsDocCashR.DocCashR; let i = index"
                    [class]="item.DocCashR_Montant!=null?'flex bg-gray-100 p-8 rounded-md shadow-md justify-between mb-4':'invisible'">
                    <div class="flex">
                      <div class="rounded-lg bg-blue-500 flex justify-content item-center text-white p-3">
                        {{ getCashRByIndex(item.DocCashR_Type).DiverSys_Libelle }}
                      </div>
                      <div mat-line class="ml-4 grid">
                        <span class="text-gray-800 font-bold">{{
                        getLibeleReglement(item.DocCashR_Type)
                      }}</span>
                        <span class="text-2xl font-bold">{{
                        item.DocCashR_Montant | number: "0.3-3"
                      }}</span>
                      </div>
                      <div mat-line *ngIf="item.DocCashR_Type == 1">
                        <span *ngIf="item.Doc_Banque">{{ item.Doc_Banque }}</span>
                        - {{ item.Doc_Ref }}
                      </div>
                      <div mat-line *ngIf="item.DocCashR_Type == 2">
                        Numéro de carte : {{ item.Doc_Ref }}
                      </div>
                    </div>
                    <button *ngIf="item.DocCashR_Montant > 0" mat-icon-button (click)="deleteReglement(item, i)">
                      <mat-icon class="text-red-500">delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
     
              <div style="max-height: 80vh; overflow-y: auto;padding: 1rem;">
                <div class="grid gap-4 md:grid md:grid-cols-3 lg:grid lg:grid-cols-3 xl:grid xl:grid-cols-3  2xl:grid 2xl:grid-cols-3">
                  <div *ngFor="let reglement of CashR_Type; index as i"
                    (click)="selectCash(reglement.DiverSys_Index)  ;indexCLiked(i)">

                    <div *ngIf="i!=7 || btnCredit "
                      class="w-full flex flex-col justify-center bg-blue-700 text-white p-3 rounded text-xl h-90 overflow-y-auto">
                      <div class="text-sm text-left w-full">
                        {{ "F" + (5 + i) }}
                      </div>
                      <div class="w-full text-center" >
                        {{ reglement.DiverSys_Libelle }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                
           
            </div>

          </mat-step>
          <mat-step>
            <ng-template matStepLabel>
              <div class="grid mb-5">
                <span class="text-xs">F1</span>
                <span class="text-xl"> Paiement </span>
              </div>
            </ng-template>
            <div class="px-20 flex justify-center">
              <div class="grid p-10 bg-gray-100 shadow-lg w-3/4">
                <div class="overflow-scroll" style="height: 50vh" *ngIf="mode!='AVANCE'">
                  <div *ngFor="let item of ListProductToshow" class="flex justify-between items-center">
                    <div class="grid">
                      <div class="font-bold text-xl text-gray-700">
                        {{ item.Art_Des }}
                      </div>
                      <div
                        class="text-2xl w-100 flex justify-center items-center m-1 font-medium py-4 px-8 rounded-full text-red-100 bg-red-700 border border-red-700">
                        <div class="text-base font-normal leading-none max-w-full flex-initial">
                          quantité : {{ item.Qte }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="font-bold text-2xl flex justify-end">
                    {{
                      sum | number: "0.3-3" }}
                    DT
                  </div>
                </div>
                <div class="overflow-scroll" style="height: 50vh" *ngIf="mode=='AVANCE'">
                  <div class="flex justify-between items-center">
                    <div class="grid">
                      <div class="font-bold text-xl text-gray-700">
                        Avance
                      </div>
                    </div>
                    <div *ngIf="dsDocCashR" class="font-bold text-2xl">
                      {{
                      dsDocCashR.DocCashR[0].DocCashR_Montant }}
                      DT
                    </div>
                  </div>
                </div>
                <div class="mb-16">
                  <div class=" mb-2 w-[25vw] bg-white  shadow-md  duration-100 hover:scale-105 hover:shadow-xl   ">
                    <div class="px-3 py-2 w-[25vw]">
                      <div class="flex items-center justify-between">
                        <p class="text-lg font-semibold text-black cursor-auto my-2">Est ce que c'est avance ? </p>
                        <mat-checkbox class="example-margin text-lg font-semibold text-black" (click)="AvanceTicket()"
                          [(ngModel)]="caseAvance">Oui</mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <button (click)="validerTicket()"
                  class="flex px-5 py-8 rounded-md text-white bg-green-500 justify-center items-center p-4">
                  <mat-icon>monetization_on</mat-icon>
                  <span toggle-label class="label px-10 font-bold text-2xl">Valider</span>
                </button>

              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
    <!-- list left -->
    <mat-divider [vertical]="true"></mat-divider>
    <div class="p-16 w-1/5 text-center overflow-scroll" style="height: 85vh;min-width: 30vw;">
      <div class="text-gray-900 font-bold text-2xl">Information generale</div>
      <hr class="my-4" />
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <mat-icon class="text-indigo-500">loyalty</mat-icon>
          <span class="text-lg font-bold text-gray-700">nombre des articles :</span>
        </div>
        <div class="ml-4 text-2xl text-indigo-700 font-bold">
          {{ getProductsCount() }}
        </div>
      </div>
      <hr class="my-4" />
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <mat-icon class="text-yellow-500"> attach_money</mat-icon>
          <span class="text-lg font-bold text-gray-700">Total :</span>
        </div>
        <div class="ml-4 text-2xl text-blue-700 font-bold">
          {{ sum | number: "0.3-3" }}
        </div>
      </div>
      <hr class="my-4" />
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <mat-icon class="text-green-500 mx-2">done</mat-icon>
          <span class="text-lg font-bold text-gray-700">Total payé :</span>
        </div>
        <div class="ml-4 text-2xl text-green-700 font-bold">
          {{ sumPayed | number: "0.3-3" }}
        </div>
      </div>
      <hr class="my-4" />
      <div class="flex items-center justify-between" *ngIf="sumPayed - sum > 0">
        <div class="flex items-center">
          <mat-icon class="text-red-500 mx-2">priority_high</mat-icon>
          <span class="text-lg font-bold text-gray-700">à rendre :</span>
        </div>
        <div class="ml-4 text-2xl text-red-700 font-bold">
          {{ sumPayed - sum | number: "0.3-3" }}
        </div>
      </div>

      <div class="flex items-center justify-between" *ngIf="-(sumPayed - sum) > 0">
        <div class="flex items-center">
          <mat-icon class="text-red-500 mx-2">priority_high</mat-icon>
          <span class="text-base font-bold text-gray-700">Reste à payer :
          </span>
        </div>
        <div class="ml-4 text-2xl text-red-700 font-bold">
          {{ -(sumPayed - sum) | number :"0.3-3"}}
        </div>
      </div>
      <div class="grid grid-cols-2 justify-center gap-3 mt-2">
        <button (click)="toggleFullscreen()" mat-stroked-button class="col-span-2">
          <mat-icon>fullscreen</mat-icon>
          <span toggle-label class="label">Plein écran</span>
        </button>

        <mat-menu xPosition="before" #groupsMenu="matMenu">
          <button (click)="selectVendeur(item)" *ngFor="let item of listeVendeur" mat-menu-item>
            {{ item.Perso_Nom }}
          </button>
        </mat-menu>

        <mat-menu xPosition="before" #liste_Caisse="matMenu">
          <button (click)="selectCaisse(caisse)" *ngFor="let caisse of listeCaisse" mat-menu-item>
            {{ caisse.Cash_Code }}
          </button>
        </mat-menu>
        <!-- <button mat-stroked-button>
                  <mat-icon>dialpad</mat-icon>
                  <span toggle-label class="label">Clavier</span>
              </button> -->

        <button [matMenuTriggerFor]="groupsMenu" mat-stroked-button class="bg-pink-800 text-white">
          <mat-icon>groups</mat-icon>
          <span toggle-label class="label">
            Vendeurs
            <br /><b>{{ selectedVendeur.Perso_Nom }}</b></span>
        </button>
        <button mat-stroked-button (click)="openArticleList()" class="bg-blue-600 text-white">
          <i class="font-size-20 fas fa-tshirt"></i>
          <span toggle-label class="label">Articles</span>
        </button>

        <button mat-stroked-button (click)="openClientList()" class="bg-purple-700 text-white">
          <mat-icon>contacts</mat-icon>
          <span toggle-label class="label">
            Clients
            <br /><b>{{ selectedClient.Tiers_RS }}</b>
          </span>
        </button>
        <button mat-stroked-button (click)="openStock()" class="bg-red-700 text-white">
          <i class="font-size-20 fas fa-warehouse"></i>
          <span toggle-label class="label"> Stock </span>
        </button>
        <button mat-stroked-button (click)="openTicketTempList(true)" class="bg-yellow-700 text-white col-span-2">
          <mat-icon>library_books</mat-icon>
          <span toggle-label class="label">Ticket Temporaire : {{ListTicketTemp.length}}</span>
        </button>
        <button [disabled]="disabledCaisse" [matMenuTriggerFor]="liste_Caisse" mat-stroked-button class="col-span-2">
          <i class="fas fa-cash-register"></i>
          <span toggle-label class="label">
            Caisse
            <br /><b>{{ selectedCaisse.Cash_Code }}</b></span>
        </button>
        <button mat-stroked-button (click)="openTicketList()" class="bg-green-600 text-white col-span-2">
          <mat-icon>library_books</mat-icon>
          <span toggle-label class="label">Tickets</span>
        </button>
        <div class="text-gray-900 font-bold text-xl col-span-2" *ngIf="listeTicketNonTerminer.length > 0">
          List des tickets créés
        </div>
        <hr class="col-span-2" />

        <button mat-stroked-button *ngFor="let ticket of listeTicketNonTerminer" (click)="setTicket(ticket)"
          class="col-span-2">
          {{ ticket.products.length }} article(s)
        </button>
      </div>
      <app-meteo class="mt-8"></app-meteo>
    </div>
    <mat-divider [vertical]="true"></mat-divider>
    <!-- RIGHT SIDEBAR -->
  </div>
  <mat-divider></mat-divider>
  <!-- FOOTER -->
  <!-- <div class="bg-1 absolute bottom-0 w-full" fxFlex="56px">
    <div fxLayout="row" class="p-8" fxLayoutAlign="space-between center">
      <div>
        <button mat-stroked-button>
          <mat-icon>play_arrow</mat-icon>
          <span toggle-label class="label">Pause</span>
        </button>
      </div>
      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-stroked-button (click)="printWithoutPrice()">
          <i class="font-size-20 fas fa-receipt px-8"></i>
          <span toggle-label class="label">Imprimer sans prix</span>
        </button>
        <button mat-stroked-button>
          <i class="font-size-20 fas fa-cash-register px-8"></i>
          <span toggle-label class="label">Ouvrir tirroire</span>
        </button>
        <button mat-stroked-button>
          <i class="font-size-20 fas fa-key px-8"></i>
          <span toggle-label class="label">Mot clé</span>
        </button>
        <!-- <button mat-stroked-button>
                    <i class="font-size-20 fas fa-comment-dollar"></i>
                </button> -->
  <!--    </div>
      <div>
        <button mat-stroked-button>
          <mat-icon>close</mat-icon>
          <span toggle-label class="label">Annuler</span>
        </button>
      </div>
    </div>
  </div> -->
</div>
<ng-template #frmDialogModePayement>
  <div class="display-flex-2 font-size-24">
    <span><b>Total :
        {{
          ((sum > 0 ? sum : 0) - (sumPayed > 0 ? sumPayed : 0)).toFixed(3)
        }}</b></span>

    <span *ngIf="value" class="text-red-500">
      <b>{{ getRest() > 0 ? "Reste" : "à rendre" }} : {{ getRest().toFixed(3) }}
      </b>
    </span>
  </div>
  <div class="display-flex">
    <div>
      <mat-form-field class="mt-10" appearance="outline">
        <mat-label>Reçu</mat-label>
        <input (keyup.enter)="addCashR()" [min]="selectedCashR != 7 ? 0 : null" [max]="selectedCashR == 7 ? 0 : null"
          autocomplete="off" #numInput [(ngModel)]="value" matInput type="number" />
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" *ngIf="selectedCashR == 1">
        <mat-label>Banque</mat-label>
        <mat-select [(ngModel)]="banque">
          <mat-option *ngFor="let myBanque of banques" [value]="myBanque">
            {{ myBanque }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" *ngIf="selectedCashR == 1 || selectedCashR == 5">
        <mat-label>Num</mat-label>
        <input autocomplete="off" matInput type="text" [(ngModel)]="numPiece" />
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" *ngIf="selectedCashR == 1 && selectedClient.Tiers_RS == 'passager'">
        <mat-label>Nom client</mat-label>
        <input autocomplete="off" matInput type="text" [(ngModel)]="nomPassager" />
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" *ngIf="selectedCashR == 1">
        <mat-label>Échéance</mat-label>
        <input matInput [(ngModel)]="echeance" [min]="getDateInterval('min')" [max]="getDateInterval('max')"
          [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <br />
    </div>
    <div>
      <div class="clavier">
        <button mat-stroked-button *ngFor="let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]" class="btn-clavier"
          (click)="writeNumber(num)">
          {{ num }}
        </button>
        <button mat-stroked-button class="btn-clavier" (click)="writeNumber('.')">
          .
        </button>
        <button mat-stroked-button class="btn-clavier" (click)="delCaractaire()">
          <mat-icon> backspace </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <br />
  <div class="display-flex">
    <button [disabled]="
        (selectedCashR == 1 && (!banque || !numPiece || !echeance)) ||
        (selectedCashR == 1 && !numPiece)
      " (click)="addCashR()" class="w-full bg-green-600 text-white py-5 rounded text-2xl" [class]="
        selectedCashR == 1 && (!banque || !numPiece || !echeance)
          ? 'pointer-events-none opacity-25 ' + selectedCashR
          : ''
      ">
      Confirmer
    </button>
  </div>
</ng-template>

<ng-template #frmTicketModePayment>
  <div class="display-flex-2 font-size-24 mb-32">
    <span><b>Total :
        {{
          ((sum > 0 ? sum : 0) - (sumPayed > 0 ? sumPayed : 0)).toFixed(3)
        }}</b></span>

    <span *ngIf="value" class="text-red-500">
      <b>{{ getRest() > 0 ? "Reste" : "à rendre" }} : {{ getRest().toFixed(3) }}
      </b>
    </span>
  </div>
  <table class="table-auto w-full">
    <thead>
      <tr class="bg-blue-700 text-center">
        <th class="w-1/6 min-w-[160px] text-lg font-semibold text-white py-16 px-12 border-l border-transparent">
          Code
        </th>
        <th class="w-1/6 min-w-[160px] text-lg font-semibold text-white py-16 px-12">
          Fournisseur
        </th>
        <th class="w-1/6 text-lg font-semibold text-white py-16 px-12">
          Libelle
        </th>
        <th class="w-1/6 min-w-[160px] text-lg font-semibold text-white py-16 px-12">
          Montant
        </th>
        <th class="w-1/6 min-w-[160px] text-lg font-semibold text-white py-16 px-12"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ticket of listTickets; index as i">
        <td class="text-center text-dark font-medium text-base py-5 px-8 bg-blue-50 border-b border-l border-blue-50">
          {{ ticket.CashTicket_Code }}
        </td>
        <td class="text-center text-dark font-medium text-base py-5 px-8 bg-white border-b border-blue-50">
          {{ ticket.CashTicket_Fournisseur }}
        </td>
        <td class="text-center text-dark font-medium text-base py-5 px-8 bg-blue-50 border-b border-blue-50">
          {{ ticket.CashTicket_Libelle }}
        </td>
        <td class="text-center text-dark font-medium text-base py-5 px-8 bg-white border-b border-blue-50">
          {{ ticket.CashTicket_Montant }}
        </td>
        <td class="text-center text-dark font-medium text-base py-5 px-8 bg-blue-50 border-b border-r border-blue-50">
          <button (click)="deleteTicketPayment(i)"
            class="border border-red-600 py-2 px-6 text-red-600 inline-block rounded hover:bg-red-600 hover:text-white">
            Supprimer
          </button>

        </td>
      </tr>
      <!-- <input type="text"[(ngModel)]="keyDown" disabled> -->
      <div class="text-center flex justify-center text-2xl rounded text-blue-700">
        {{ keyDown }}
      </div>
    </tbody>
  </table>

  <div class="display-flex mt-16">
    <button [disabled]="listTickets.length == 0" (click)="addCashR()"
      class="w-full bg-green-600 text-white py-5 rounded text-2xl" [class]="
        listTickets.length == 0
          ? 'pointer-events-none opacity-25 ' + selectedCashR
          : ''
      ">
      Confirmer
    </button>
  </div>
  <input hideKeyboard type="text" #code id="hiddenInput" style="position: absolute; left: -1000px; top: -1000px"
    (paste)="scannedWithPm($event)" (blur)="refocus()" autofocus />
</ng-template>
<ng-template #frmEchange>
  <div class="display-flex-end">
    <div>
      <button (click)="validerEchange()" mat-stroked-button class="bg-green-500 text-white">
        <mat-icon>done</mat-icon>
        Valider
      </button>
    </div>
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Code ticket</mat-label>
    <input autocomplete="off" #numInput [(ngModel)]="codeTicket" matInput />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Code article</mat-label>
    <input autocomplete="off" #numInput [(ngModel)]="codeArticle" matInput />
  </mat-form-field>
</ng-template>
<ng-template #frmAvance>
  <div class="display-flex-end">
    <div>
      <button (click)="validerAvance()" mat-stroked-button class="bg-green-500 text-white">
        <mat-icon>done</mat-icon>
        Valider
      </button>
    </div>
  </div>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Code ticket</mat-label>
      <input autocomplete="off" #numInput [(ngModel)]="codeTicketAvance" matInput />
    </mat-form-field>
  </div>
</ng-template>
<ng-template #frmSoldeCaisseOuverture>
  <div class="display-flex-end">
    <div>
      <button (click)="closeDialog()" mat-stroked-button>Ok</button>
    </div>
  </div>
  <mat-form-field appearance="outline" *ngIf="dsJournerOc">
    <mat-label>Montant</mat-label>
    <input autocomplete="off" min="0" #inputMntCaisse [(ngModel)]="dsJournerOc.CashD[0].CashD_MAlimentation" matInput
      type="number" />
  </mat-form-field>
</ng-template>
<ng-template #frmListeClient>
  <span class="text-gray-800 font-bold text-3xl mr-40">Sélectionner un client</span>

  <div class="flex justify-between">
    <app-recherche class="w-full" #client [api]="generalService.api" [numColonneToShow]="1"
      (lineSelected)="clientSelected($event)" (ChampEnter)="selectionClientChange($event)" recherche="TierType"
      [param]="'1'" name="Machine_Emp" placeholder="Client">
    </app-recherche>

    <button (click)="showAddNewClient()" class="bg-green-500 text-white mt-4 mb-24 ml-10 text-3xl rounded-md"
      style="width: 62px">
      <span>+</span>
    </button>
  </div>
  <div class="display-flex" *ngIf="client && client.selectedRow">
    <img class="customer-avatar" [src]="client.selectedRow.image" />
    <div>
      <b>Code: </b>{{ client.selectedRow.Tiers_Code }}
      <br />
      <b>Client: </b>{{ client.selectedRow.Tiers_RS }}
    </div>
  </div>
  <div class="display-flex-end w-full" *ngIf="client && client.selectedRow">
    <button type="submit" (click)="validerSelectionClient()" mat-stroked-button
      class="bg-green-500 text-white w-full mt-10">
      <mat-icon>done</mat-icon>
      Valider
    </button>
  </div>
</ng-template>
<ng-template #frmListeArticle>
  <span class="text-gray-800 font-bold text-3xl mr-40">Sélectionner un article</span>
  <app-recherche [lateInputVal]="articleTemp" #article [api]="generalService.api" [numColonneToShow]="4"
    [numColonneToReturn]="0" recherche="apiarticle" placeholder="Article">
  </app-recherche>
  <div class="display-flex" *ngIf="article && article.selectedRow">
    <img class="customer-avatar" onerror="src='/assets/1.jpg'" [src]="
        imageDomain +
        
        article.selectedRow.Art_Code +
        '.JPG'
      " />
    <div>
      <b>Code: </b>{{ article.selectedRow.Art_Code }}
      <br />
      <b>Article: </b>{{ article.selectedRow.Art_Des }}
      <br />
      <!-- <b>Taille: </b>{{ article.selectedRow.Art_Car1 }}
      <br />
      <b>Couleur: </b>{{ article.selectedRow.Art_CAr2 }} -->
    </div>
  </div>
  <button *ngIf="article && article.selectedRow" (click)="validerSelectionArticle()"
    class="bg-green-500 text-white px-4 py-2 w-full text-2xl rounded-md shadow my-3">
    Valider
  </button>
</ng-template>
<ng-template #addNewClient>
  <div class="text-2xl font-bold text-gray-700">Nouveau client</div>
  <div class="grid grid-cols-2 gap-4">
    <mat-form-field class="w-full col-span-2" appearance="outline">
      <mat-label>Nom</mat-label>
      <input matInput [(ngModel)]="clientToAdd.Tiers_RS" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Adresse</mat-label>
      <input matInput [(ngModel)]="clientToAdd.Tiers_Adresse" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Ville</mat-label>
      <input matInput [(ngModel)]="clientToAdd.Tiers_Ville" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput [(ngModel)]="clientToAdd.Tiers_Contact_mail" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>tel</mat-label>
      <input matInput [(ngModel)]="clientToAdd.Tiers_Contact_Mobile" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Credit</mat-label>
      <mat-select [(ngModel)]="clientToAdd.Tiers_Famille">
        <mat-option *ngFor="let c of ListCredit" [value]="c.value">
          {{c.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button class="bg-green-500 text-white px-4 py-2 w-full text-2xl rounded-md shadow my-3 col-span-2"
      (click)="addNewClientRequest()">
      Ajouter
    </button>
  </div>
</ng-template>
<ng-template #frmRemiseArticle>
  <div class="display-flex-end">
    <div>
      <button (click)="validerRemise()" mat-stroked-button style="margin-right: 10px">
        <mat-icon>done</mat-icon>
        Valider
      </button>
    </div>
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Quantité</mat-label>
    <input autocomplete="off" min="1" (focusout)="validerQte()" (input)="calculerMontantRemiseArticle()" #inputQte
      [(ngModel)]="Sto_Q" matInput type="number" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Taux remise</mat-label>
    <input autocomplete="off" min="0" (input)="calculerTauxRemiseArticle()" #numInput [(ngModel)]="DocCashD_TxRem"
      matInput type="number" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Montant remise</mat-label>
    <input autocomplete="off" min="0" (input)="calculerMontantRemiseArticle()" #numInput [(ngModel)]="DocCashD_Rem"
      matInput type="number" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Montant article</mat-label>
    <input autocomplete="off" disabled="true" #numInput [(ngModel)]="montantArticleApretRemise" matInput
      type="number" />
  </mat-form-field>
</ng-template>
<ng-template #frmlisteStock>
  <div *ngIf="columnStock && listeStockIsloadet; else attente"></div>
  <ng-template #attente>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
  <div class="display-flex-end">
    <div>
      <button (click)="closeDialog()" mat-stroked-button>Fermer</button>
    </div>
  </div>
  <app-liste *ngIf="columnStock" #listeStockComponent [showSort]="true" [showFilter]="true" [dataSource]="listeStock"
    [columns]="columnStock">
  </app-liste>
</ng-template>

<ng-template #frmListeTicketTemp>
  <div *ngIf="!isloding">
    <div class="spinner">
      <div class="circle one"></div>
      <div class="circle two"></div>
      <div class="circle three"></div>
    </div>
  </div>
  <div *ngIf="isloding">
    <div class="flex flex-row justify-between gap-4">
      <span class="text-gray-800 font-bold text-3xl mr-40 ">Sélectionner une Ticket</span>
      <span class="text-gray-800 font-bold text-3xl "> {{ListTicketTemp.length}}</span>
    </div>

    <div class="flex flex-col  gap-4 overflow-y-auto">
      <div *ngFor="let ticket of ListTicketTemp"
        class="border p-2 shadow rounded-xl flex flex-col justify-between gap-2 bg-gray-100 hover:bg-blue-200"
        (click)="OpenTicketTemp(ticket.docNum)">
        <div class="flex flex-row justify-between gap-2 p-2" *ngIf="ticket.date && ticket.docNum">
          <span class="text-2xl font-bold text-black">{{ticket.date.substring(0,10)}} </span>
          <span class="text-2xl font-bold text-black">{{ticket.date.substring(11,19)}}</span>
        </div>
        <div *ngFor="let art of ticket.article;let i=index;" class="flex flex-row justify-between gap-2">
          <!-- &nbsp;{{art.prix | number :"1.3-3"}} -->
          <span class="text-xl font-bold text-gray-600">{{art.qte}}x
            {{art.des}}</span>
          <span class="text-2xl font-bold text-black flex justify-between">{{art.prix | number :"1.3-3" }}dt </span>
        </div>
        <!-- div class="flex flex-row justify-between gap-4">
          <span class="text-xl font-bold text-gray-600 ">Montant:</span>
        </div> -->
      </div>
    </div>

    <button *ngIf="ticketTempRech && ticketTempRech.selectedRow" (click)="validerSelectionTicketTemp()"
      class="bg-green-500 text-white px-4 py-2 w-full text-2xl rounded-md shadow my-3">
      Valider
    </button>
  </div>
</ng-template>
